/* ----------------------------------------------------------------------------
   SupplySideLayout — wraps every /supply/* route with:
     <div className='supply-scope'>  (scoped mockup stylesheet — plain CSS classes
     like .card/.field/.btn used by most wizard steps, e.g. StepCode.js/StepMode.js)
   MUI components (Card, Button, Chip, Tab, Tooltip, ...) now inherit the app's
   own root theme directly — no nested <ThemeProvider> — so they match the rest
   of the admin panel exactly, the same as every other module (e.g. d2c-pricing-
   agent, which also has no theme override of its own).
   The app's <Layout> still provides the real sidebar + topbar; this only skins
   the page content area.
   It also resets the window scroll on every /supply/* route change: the page
   content scrolls with the window and React Router keeps the offset, so opening
   a code's deep-dive from the bottom of a long list landed at the bottom of the
   new page. Scoped here so the legacy pages are untouched. */
import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {useLocation} from 'react-router-dom'
import Box from '@mui/material/Box'
import './supply-side-scoped.css'

export default function SupplySideLayout({children}) {
  const {pathname} = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <Box
      className='supply-scope'
      sx={{
        minHeight: 'calc(100vh - 60px)',
        bgcolor: 'background.default',
        color: 'text.primary',
        p: {xs: 2, md: 3},
      }}
    >
      {children}
    </Box>
  )
}

SupplySideLayout.propTypes = {
  children: PropTypes.node,
}
